import * as t from 'io-ts';
export const userRole = t.union([
  t.literal('Admin'),
  t.literal('ResellerAdmin'),
  t.literal('SchoolAdmin'),
  t.literal('Teacher'),
  t.literal('Student'),
]);
export type UserRole = t.TypeOf<typeof userRole>;
